import { Inject, Injectable } from '@angular/core';
import { IExtendedWindow } from '../../../type_definitions/datatypes';
import * as _ from 'underscore';

@Injectable()
export class AnalyticsService {
  private analyticsArgs:string[] = [];

  constructor(
    @Inject(Window) private window:IExtendedWindow
  ) {
    /**/
  }

  public ga(...args:any[]):void {
    if (!_.isEqual(args, this.analyticsArgs)) {
      this.analyticsArgs = args;
      this.window.gtag.apply(window, args);
    }
  }
}